import { IUserReplacement } from "@/interfaces";
import { Space, Switch, Typography } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

interface ISetAllowBlankToggleProps {
  selectedRows: IUserReplacement[];
  toggleValue: boolean;
  handleToggle: (checked: boolean) => void;
}

export const SetAllowBlankToggle = ({
  selectedRows,
  toggleValue,
  handleToggle,
}: ISetAllowBlankToggleProps) => {
  const intl = useIntl();
  const [toggleVisible, setToggleVisible] = useState(false);
  useEffect(() => {
    const enabledAllowBlank =
      selectedRows?.length > 0 &&
      selectedRows?.every((row) => row?.isProjectHeader || row?.allowBlank);

    setToggleVisible(enabledAllowBlank);

    if (!enabledAllowBlank) {
      handleToggle(false);
    }
  }, [selectedRows, handleToggle]);

  return (
    toggleVisible && (
      <Space>
        <Typography.Text strong>
          {intl.formatMessage({
            id: "userReplacement.ReplaceWithBlank",
          })}
        </Typography.Text>
        <Switch
          checked={toggleValue}
          data-test-id={`user-replace-replace-with-blank-switch`}
          checkedChildren={intl.formatMessage({
            id: "general.yes",
          })}
          unCheckedChildren={intl.formatMessage({
            id: "general.no",
          })}
          onClick={(checked) => handleToggle(checked)}
        />
      </Space>
    )
  );
};
